export const ROUTE_PATHS = {
  HOME: '/',
  LEGAL: '/ho-so-phap-ly',
  ELIGIBILITY: '/doi-tuong-dang-ky',
  ANNOUNCEMENT: '/cong-bo-thong-tin',
  PROGRESS: '/tien-do',
} as const;

export interface ProjectInfo {
  name: string;
  shortName?: string;
  investor?: string;
  address: string;
  district: string;
  city: string;
  towers: {
    name: string;
    floors: number;
    basements?: number;
    landArea?: number;
    constructionArea?: number;
    constructionDensity?: number;
    totalFloorArea?: number;
    landUsageCoefficient?: number;
    totalUnits?: number;
    population?: number;
  }[];
  totalUnits: number;
  areaRange: {
    min: number;
    max: number;
  };
  pricePerSqm: number;
  startDate: string;
  expectedHandover: string;
  description: string;
  features: string[];
  infrastructure: string[];
}

export interface LegalDoc {
  id: string;
  name: string;
  status: 'Đã ban hành' | 'Đang xử lý';
  date: string;
  issuingAuthority: string;
  documentNumber: string;
  downloadUrl?: string;
}

export interface EligibilityGroup {
  id: string;
  groupNumber: number;
  name: string;
  description: string;
  isMainGroup?: boolean;
}

export interface ProcessStep {
  id: string;
  stepNumber: number;
  title: string;
  description: string;
  duration: string;
}

export interface AnnouncementItem {
  id: string;
  title: string;
  category: 'Thông báo dự án' | 'Giá bán' | 'Tiến độ' | 'Hồ sơ' | 'Thông tin dự án';
  date: string;
  summary: string;
  content?: string;
}

export interface ProgressPhase {
  id: string;
  phaseNumber: number;
  name: string;
  status: 'Hoàn thành' | 'Đang thi công' | 'Chưa bắt đầu';
  startDate: string;
  endDate: string;
  completionPercentage: number;
  description: string;
}

export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export interface Condition {
  id: string;
  title: string;
  description: string;
  requirements: string[];
}

export interface RequiredDoc {
  id: string;
  name: string;
  description: string;
  required: boolean;
}

export interface ApartmentType {
  type: string;
  area: string;
  estimatedPrice: string;
}

export interface TimelineItem {
  quarter: string;
  year: string;
  milestone: string;
}

export interface UpdateLog {
  date: string;
  description: string;
}
